import React from 'react';
import classes from './OfficeStatus.module.css';

const OfficeStatus = () => {
  return (
    <div className={classes.bodyStatus}>
      <span className={classes.statusText}>Офис ✅</span>
    </div>
  );
};

export default OfficeStatus;